if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.stockProduct = document.querySelector('[js-product-input]');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.condenseProductsData = document.querySelector('[js-upsell-condense]')
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        this.quantitySelected = 1
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      recursivelyCondenseItems(items, config){
        let isItemsCondensed = false

        config.forEach(condenseItem => {
          let fromIds = condenseItem.from.replaceAll(' ', '').split(',').map(id => id.trim())
          let toId = condenseItem.to.toString()
      
          const hasAllKeys = fromIds.every(fromId => items.some(item => item.id.toString() === fromId))
          if (hasAllKeys) {
            // Remove fromIds from items
            fromIds.forEach(fromId => {
              const index = items.findIndex(item => item.id.toString() === fromId)
              if (index > -1) {
                items.splice(index, 1)
              }
            })

            // Add newly condensed toId
            items.push({ id: toId, quantity: this.quantitySelected })
      
            // Trigger re-condensing each time an item is condensed
            isItemsCondensed = true
          }
        })        

        // If any condensing occurred, run the function again
        if (isItemsCondensed) {
          return this.recursivelyCondenseItems(items, config)
        }

        // If no condensing occurred, return the final items array
        return items
      }

      condenseProducts(items){
        try {
          const config = JSON.parse(this.condenseProductsData.textContent)?.condense_to_one_item
          if (!config) return items

          // Duplicate items array incase any errors.
          let itemsToCondense = [...items]

          return this.recursivelyCondenseItems(itemsToCondense, config)
        } catch (error) {
          console.error('Error condensing items:', error)
          return items
        }  
      }

      overrideProducts(formData){
        let { items } = formData;
        let newFormData = formData
        let updatedItems = [];
        
        // Hard-coded ID values as per old functionality
        const SUPPORT_SEAT_ID = '40170740777038';
        const TRIKE_CARGO_ID = '40186017808462';
        const TRIKE_CARGO_AND_SEAT = '40034954903630';
        
        const supportSeatItem = items.find(item => item.id === SUPPORT_SEAT_ID);
        const trikeCargoItem = items.find(item => item.id === TRIKE_CARGO_ID);
        
        if (supportSeatItem && trikeCargoItem) {
          updatedItems.push({
            id: TRIKE_CARGO_AND_SEAT,
            quantity: this.quantitySelected
          });
        
          updatedItems = updatedItems.concat(items.filter(item => item.id !== SUPPORT_SEAT_ID && item.id !== TRIKE_CARGO_ID));
        } else {
          updatedItems = items;
        }

        if(this.condenseProductsData){
          newFormData.items = this.condenseProducts(updatedItems)
        } else {
          newFormData.items = updatedItems
        }

        return newFormData
      }

      buildFormData(){
        console.log("Building form data...")
        this.stockProduct.checked = true
        const productContainer = this.closest('product-info')

        console.log("productContainer: ", productContainer)

        const originalFormData = new FormData(this.form)
        const quantity = originalFormData.get('quantity')
        this.quantitySelected = quantity

        let updatedFormData = {
          items: []
        }

        if(productContainer){
          const upsellItems = document.querySelectorAll('input.upsell-item-checkbox')
          Array.from(upsellItems).forEach(item => {
            console.log("item", item)
            console.log("item checked", item.checked)
          })
          const selectedItems = upsellItems ? Array.from(upsellItems).filter(item => item.checked) : []

          for (let index = 0; index < selectedItems.length; index++) {
            const upsellItem = selectedItems[index];
            const productId = upsellItem.getAttribute('data-product-id')

            
            const excludeStockBike = upsellItem.getAttribute('data-exclude-stock-bike') === 'true' ? true : false
            if(excludeStockBike) this.stockProduct.checked = false

            console.log("upsellItem", upsellItem)
            console.log("productId", productId)

            updatedFormData.items.push({
              id: productId,
              quantity
            })

          }
        }

        if(updatedFormData.items.length > 0){
          const sections = originalFormData.get('section-id')

          console.log(updatedFormData)

          if(sections){
            updatedFormData.sections = sections
          }

          if(this.stockProduct.checked){
            updatedFormData.items.push({
              id: this.stockProduct.getAttribute('data-product-id'),
              quantity: 1
            })
          }

          return { formData: this.overrideProducts(updatedFormData), type: 'JSON' }

        } else {
          return { formData: originalFormData, type: 'Form' }
        }

      }

      onSubmitHandler(evt) {
        console.log("Submit handler...")
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        let { formData, type } = this.buildFormData();

        if (this.cart) {
          const sectionsToRender = this.cart.getSectionsToRender().map((section) => section.id)
          
          if(type === 'JSON'){
            formData.sections = sectionsToRender
            formData.sections_url = window.location.pathname
            config.headers['Content-Type'] = 'application/json';
            config.body = JSON.stringify(formData)
          } else {
            formData.append(
              'sections',
              sectionsToRender
            );
            formData.append('sections_url', window.location.pathname);
            delete config.headers['Content-Type']
            config.body = formData
          }
          this.cart.setActiveElement(document.activeElement);
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: type === 'JSON' ? formData.items[0].id : formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: type === 'JSON' ? formData.items[0].id : formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || document.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.classList.toggle('hidden', !errorMessage);
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
